const de = {
  alerts: {
    saveSuccessful: 'Die Rechnung wurde erfolgreich erstellt.',
    saveFailed: 'Die Rechnung konnte nicht erstellt werden.',
    importNotAllowed:
      'Sie haben dieser Seite nicht die Berechtigung erteilt aus ihrer Zwischenablage zu lesen.',
    importFailed: 'Beim Import trat ein Problem auf: {{cause}}',
    noImportResult: 'In der Zwischenablage wurden keine gültigen Nummern gefunden.',
    importSuccess: 'Der Import war erfolgreich.',
    errorLoading: 'Rechnungen konnten nicht geladen werden.',
    importEmpty: 'Der Import ist leer.',
    cancelRequestSuccess: 'Der Änderungsantrag wurde erfolgreich gestellt.',
    cancelRequestError: 'Der Änderungsantrag konnte nicht gestellt werden.',
    processCancelRequestSuccess: 'Der Änderungsantrag wurde erfolgreich bearbeitet.',
    processCancelRequestError: 'Der Änderungsantrag konnte nicht bearbeitet werden.',
    processInvoiceSuccess: 'Die Rechnung wurde erfolgreich bearbeitet.',
    processInvoiceError: 'Die Rechnung konnte nicht bearbeitet werden.'
  },
  create: {
    title: 'Neue Rechnung für Firma "{{company.name}}"'
  },
  steps: {
    customerSearch: 'Kundensuche',
    offers: 'Stellenanzeigen',
    periods: 'Anzeigenzeiträume',
    invoiceSettings: 'Rechnungseinstellungen'
  },
  tabs: {
    openOffers: 'Nicht abgerechnet',
    existingInvoices: 'Bestehende Rechnungen',
    openChangeRequests: 'Änderungsanfragen',
    paidInvoices: 'Bezahlte Rechnungen'
  },
  customerInFSV: 'Gefundener FSV Kunde',
  jobmarketCustomer: 'Jobbörse Firmendaten',
  noCustomerFound: 'Kein passender Kunde gefunden',
  noCustomerSelected: 'Kein Kunde ausgewählt',
  noCustomerInfoText:
    'Wenn die Schaltfläche "Kein passender Kunde gefunden" angeklickt ist, werden die Kundendaten aus den "Jobbörse Firmendaten" übernommen. Das Ausgangsrechnungstool versucht diesen Kunden dann über folgende Werte in der  Datenbank zu finden: Vorname, Nachname, Email, Firmenname, UmsatzsteuerId, Adresse. Falls diese Werte mit keinem der hinterlegten Kunden übereinstimmen, wird ein neuer Kunde mit der ZahlungspartnerId 0 angelegt.',
  selectedOffersCount: '{{selected}} von {{total}} Stellenanzeigen zur Abrechnung ausgewählt',
  selectedPeriodsCount: '{{selected}} von {{total}} Anzeigezeiträumen zur Abrechnung ausgewählt',
  disabledJobOffers: {
    disabledPeriodsWarningTitle: 'Hinweis',
    disabledPeriodsWarning:
      'Ausgegraute Stellenangebote können innerhalb der dreitägigen Kulanzfrist nicht abgerechnet werden. Während dieser Zeit hat das Unternehmen die Möglichkeit, den Jobtyp der Stellenangebote zu ändern.',
    disabledPeriodsTooltip:
      'Das Stellenangebot kann innerhalb der dreitägigen Kulanzfrist nicht abgerechnet werden. Während dieser Zeit hat das Unternehmen die Möglichkeit, den Jobtyp des Stellenangebots zu ändern.'
  },
  invoiceAddress: 'Rechnungsadresse',
  taxInformation: 'Steuerinformationen',
  invoiceEmail: 'Rechnungsemail',
  taxId: 'Ust-IdNr.',
  taxNumber: 'Steuernummer',
  ksNumber: 'Kassennummer',
  stokNumber: 'STOK-Nummer',
  ksNumbersLeft: 'Noch {{left}} Kassennummern verfügbar',
  stokNumbersLeft: 'Noch {{left}} STOK-Nummern verfügbar',
  earliestPeriod: 'Frühester Zeitraum',
  periodCount: 'Anzahl Zeiträume',
  periodId: 'Zeitraum-ID',
  offerId: 'Stellen-ID',
  offerIdTitle: 'Stellen-ID [Titel]',
  companyId: 'Firmen-ID',
  openOffers: 'Zeiträume zur Abrechnung',
  openAmount: 'Offener Betrag',
  actions: 'Aktionen',
  createInvoice: 'Rechnung erstellen',
  invoiceId: 'Rechnungs-ID',
  createdAt: 'Rechnungsdatum',
  amount: 'Betrag',
  noInvoicesToCreate: 'Es sind keine Rechnungen zur Berechnung vorhanden.',
  noInvoices:
    'Es sind bisher keine Rechnungen vorhanden. Ggf. müssen Sie die Filtereinstellungen anpassen.',
  changeInvoice: 'Änderungsanfrage',
  changeInvoicePlaceholder: 'Geben Sie hier Ihren Änderungsgrund an',
  changeInvoiceDescription:
    'Geben Sie bitte einen Grund an, warum die Rechnung geändert werden soll.',
  changeReason: 'Änderungsgrund',
  changeState: 'Änderungsstatus',
  changeStates: {
    pending: 'In Bearbeitung',
    accepted: 'Änderung Akzeptiert'
  },
  denyChangeDescription: 'Wollen Sie die diese Rechnung stornieren?',
  acceptChangeDescription: 'Haben Sie diese Rechnung bearbeitet und wollen diese neu erstellen?',
  markAsPaid: 'Bezahlt',
  markAsUnpaid: 'Nicht bezahlt',
  markInvoiceAsPaidTitle: 'Rechnung bezahlt',
  markInvoiceAsPaidDescription: 'Wollen Sie diese Rechnung als bezahlt markieren?',
  importModalTitle: 'STOK-/Kassennummern importieren',
  allowClipboardPermissionTitle: 'Berechtigung zum Lesen der Zwischenablage erteilen',
  allowClipboardPermission:
    'Nach Bestätigung dieses Dialogs wird der Browser Sie fragen ob diese Seite aus Ihrer Zwischenablage lesen darf. Diese Berechtigung müssen Sie erteilen. Die Daten werden lokal verarbeitet und nur dann an den Server geschickt, wenn sie der gewünschten Form entsprechen. Hierbei entstehen keine Sicherheitsprobleme für Sie.',
  permissionDeniedTitle: 'Keine Berechtigung',
  permissionDenied:
    'Sie haben der Seite die Berechtigung zum Lesen der Zwischenablage verweigert. Die Berechtigung muss erteilt werden, damit der Import funktioniert. Die Lösung für dieses Problem ist browserabhängig. Fragen Sie dazu bitte im Rechenzentrum nach oder suchen eine Lösung über Google.',
  recreate: 'Neu generieren',
  paidOn: 'Zahlungseingang am: {{date}}',
  paymentDate: 'Zahlungseingang',
  cancel: 'Stornieren',
  editAndRecreate: 'Bearbeiten und neu Erstellen',
  invoice: 'Rechnung',
  cancelInvoice: 'Storno',
  openInDMS: 'In DMS öffnen'
};

export default de;
export type InvoicesTranslation = typeof de;
